import React from "react";

const BTNCLOOverviewContent = () => {
  return (
    <div className="p-8">
      <div className="space-y-8">
        {/* Definition Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Apa itu BTNCLO?</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <p className="leading-relaxed text-base-content/70">
              BTNCLO terdapat di 13 Polda yang mempunyai wilayah perbatasan
              karena BTNCLO berfungsi sebagai upaya untuk menanggulangi
              kejahatan-kejahatan di perbatasan.
            </p>
          </div>
        </div>

        {/* Tasks Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Tugas BTNCLO</h2>
          <div className="grid gap-4">
            {[
              "Mengkoordinasikan hal-hal terkait kejahatan transnasional dalam penyelidikan suatu kasus kejahatan",
              "Membantu proses penyelidikan dan mempermudah pihak-pihak terkait dalam proses penyidikan apabila Polda melakukan penyelidikan terkait kasus transnasional di perbatasan",
              "Membuat informasi intelijen kepolisian sebagai bahan masukan dan pertimbangan Kadivhubinter Polri dan Kapolda terkait kebijakan keamanan di wilayah perbatasan",
              "Membangun jaringan kepolisian dengan mitra kerja asing di dalam dan luar negeri",
            ].map((task, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <div className="bg-primary rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <span className="text-primary-content font-semibold text-sm">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-base-content/70 leading-relaxed">{task}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Functions Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Fungsi BTNCLO</h2>
          <div className="grid gap-4">
            {[
              "Sebagai penghubung Divhubinter Polri di wilayah perbatasan dalam rangka penanganan kejahatan transnasional",
              "Sebagai fasilitator penanganan kejahatan internasional dengan mitra kerja asing di dalam dan luar negeri yang memiliki perbatasan",
              "Sebagai sumber informasi intelijen kepolisian dalam rangka penanggulangan kejahatan transnasional",
            ].map((func, index) => (
              <div key={index} className="bg-base-100 rounded-lg p-6">
                <div className="flex items-start gap-4">
                  <div className="bg-secondary rounded-full w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <span className="text-secondary-content font-semibold text-sm">
                      {index + 1}
                    </span>
                  </div>
                  <p className="text-base-content/70 leading-relaxed">{func}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BTNCLOOverviewContent;
